export const getSelectionRanges = (cellRanges) => {
  const columnCount = cellRanges[0].columns.length;
  const startRow = cellRanges[0].startRow.rowIndex;
  const endRow = cellRanges[0].endRow.rowIndex;
  const rowCount = endRow - startRow + 1;

  return { columnCount, rowCount };
};
